import { render, staticRenderFns } from "./Acuerdos2.vue?vue&type=template&id=1bda131b&scoped=true&"
import script from "./Acuerdos2.vue?vue&type=script&lang=js&"
export * from "./Acuerdos2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda131b",
  null
  
)

export default component.exports